var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PowerBILoader',{attrs:{"reportTitle":'Customer Pricing Performance',"reportUrl":'https://app.powerbi.com/reportEmbed?reportId=6e02a777-4e9d-405f-9a67-2cacf99d9866&autoAuth=true&ctid=1bda8acf-807e-4a1c-b603-a2b6bb566cdb&navContentPaneEnabled=false'}})
}
var staticRenderFns = []

export { render, staticRenderFns }